/* ============================================================
   Özel Paketler — PDP paket builder (Faz 2, Faz B'de heterojen slot desteği)
   Volume paket seçicide 2'li/3'lü kademe seçilince VEYA bir combo
   (Daily/Full Fit, Space Bag) kartına tıklanınca modal açılır.
   Akordiyon UX (yumuşak geçişli):
   - Yapı bir kez kurulur; aç/kapa CSS ile animasyonlu (grid-rows 0fr↔1fr).
   - Her slot bir akordiyon; sıradaki eksik slot otomatik açıktır.
   - Kilitli slot (mevcut ürün / sepette olan) baştan dolu görünür; PDP'de
     beden seçiliyse dolu gelir. Diğer slotlar bir GRID içinde KENDİ
     koleksiyonlarının ürünlerini gösterir (volume'da hepsi aynı koleksiyon,
     combo'da her slot farklı koleksiyon olabilir); ürünün stoktaki bedenine
     tıklanınca slot dolar → akordiyon kapanır → sıradaki açılır.
   - Tüm slotlar dolunca yalnız YENİ seçilenler /cart/add.js ile eklenir
     (kilitli+sepette olanlar tekrar eklenmez) → drawer açılır.
   - Paket YARIM kalıp modal kapatılırsa seçimler ÇÖPE GİTMEZ: kullanıcı
     modalda en az bir seçim yaptıysa, dolu slotlar (sepette olanlar hariç)
     kapanışta sessizce sepete eklenir ve küçük bir toast bilgi verir.
     Paket indirimi tamamlanınca oluşur; sepet modülü eksiği zaten hatırlatır.
   - Sayaç ürün bazlı sayar: slotta ürün varsa "dolu" (PDP'den açılışta
     1/N ile başlar); beden eksikse buton "Beden seç" der — "1 ürün var
     ama 0/3" çelişkisi yok.
   - Tükenen BEDEN soluk/çizili ve seçilemez gösterilir (PDP ile tutarlı);
     hiç stoğu olmayan ÜRÜN grid'de listelenmez.
   ============================================================ */
(function () {
  'use strict';

  // PDP'de #fos-builder-data var (mevcut ürün + eşleşen volume koleksiyonu).
  // Sepetten/combo kartından açılırken de kullanılır — window.fosBuilder.open(...)
  // ile dışarıdan parametreyle açılabilir; window.fosBuilder.currentProduct()
  // mevcut ürünü (cross-sell-combo.js için) paylaşır.
  var dataEl = document.getElementById('fos-builder-data');
  var DATA = null;
  if (dataEl) {
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { DATA = null; }
  }
  var COLLECTION = DATA ? DATA.collection : null;
  var CUR = DATA ? DATA.current : null;

  /* i18n: metinler theme.liquid'deki window.fosI18n adasından (locales/*.json)
     gelir; ada yoksa Türkçe fallback. __X__ yer tutucularını tt() doldurur. */
  var I18N = window.fosI18n || {};
  function tt(key, fallback, repl) {
    var s = (typeof I18N[key] === 'string' && I18N[key]) ? I18N[key] : fallback;
    if (repl) {
      for (var k in repl) { s = s.split('__' + k + '__').join(repl[k]); }
    }
    return s;
  }

  var COLLECTION_NOUNS = I18N.nouns || {
    't-shirts': 't-shirt',
    'caps': 'cap',
    'hoodies': 'hoodie',
    'sweatshirts-hoodies': 'hoodie',
    'rotation-set': 'hoodie',
    'kazak': 'kazak',
    'socks': 'çorap',
    'canta': 'çanta'
  };
  function slotNoun(handle) {
    return COLLECTION_NOUNS[handle] || tt('nounFallback', 'ürün');
  }

  function slotNounTitle(handle) {
    var locale = document.documentElement.lang || 'tr';
    return slotNoun(handle)
      .split('-')
      .map(function (part) {
        return part ? part.charAt(0).toLocaleUpperCase(locale) + part.slice(1) : part;
      })
      .join('-');
  }

  var REQUIRED_PRICE_BY_COLLECTION = {
    't-shirts': 165000,
    'caps': 89000,
    'hoodies': 295000,
    'sweatshirts-hoodies': 295000,
    'rotation-set': 295000,
    'kazak': 345000,
    'canta': 395000
  };
  function requiredPriceCents(handle) {
    return REQUIRED_PRICE_BY_COLLECTION[handle] || 0;
  }

  var collectionCache = {}; // handle -> ürünler
  var inflightCollection = {}; // handle -> süren istek (aynı koleksiyonu iki kez indirme)
  var overlay = null;
  var state = null; // { qty, totalCents, slots:[{collection,product,variant,locked,inCart}], active, accEls }
  var openRequest = 0;
  var pendingCartWrite = window.Promise.resolve();

  /* Shopify CDN görselini istenen genişlikte iste: grid'de küçük (hızlı),
     hızlı incelemede büyük (net). CDN dışı URL'lere dokunmaz. */
  function imgUrl(src, w) {
    if (!src) return '';
    if (!/cdn\.shopify\.com|\/cdn\//.test(src)) return src;
    if (/[?&]width=/.test(src)) return src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    return Math.round(cents / 100).toLocaleString('tr-TR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }) + ' TL';
  }

  /* ----- küçük toast (drawer'ı açmadan "oldu" geri bildirimi) -----
     Global: window.fosToast(mesaj, { error, cta }) — cross-sell-combo.js
     yarım kalan kombin seçimlerinde aynı toast'ı kullanır. */
  var toastEl = null;
  var toastTimer = null;

  function openCartDrawer() {
    if (window.goCart && typeof window.goCart.fetchAndOpenCart === 'function') {
      window.goCart.fetchAndOpenCart();
      return;
    }
    var trigger = document.querySelector('.js-go-cart-trigger');
    if (trigger) trigger.click();
  }

  /* Drawer'ı AÇMADAN sepet sayaçlarını/içeriğini tazele. */
  function refreshCartSilently() {
    if (window.goCart && typeof window.goCart.fetchCart === 'function') {
      try { window.goCart.fetchCart(); } catch (e) {}
    }
  }

  function hideToast() {
    if (toastEl) toastEl.classList.remove('is-in');
  }

  function showToast(message, opts) {
    opts = opts || {};
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'fos-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('is-error', !!opts.error);
    toastEl.innerHTML =
      '<span class="fos-toast__icon" aria-hidden="true"></span>' +
      '<span class="fos-toast__msg">' + escapeHtml(message) + '</span>' +
      (opts.cta ? '<button type="button" class="fos-toast__cta">' + escapeHtml(opts.cta) + '</button>' : '');
    if (opts.cta) {
      toastEl.querySelector('.fos-toast__cta').addEventListener('click', function () {
        hideToast();
        openCartDrawer();
      });
    }
    // aynı toast peş peşe gelirse animasyon yeniden başlasın
    toastEl.classList.remove('is-in');
    void toastEl.offsetWidth;
    toastEl.classList.add('is-in');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, opts.error ? 4200 : 3600);
  }

  window.fosToast = showToast;

  /* Shopify tek-varyant başlığı "Default Title" — müşteriye hiçbir yerde
     gösterilmez, "Tek beden" yazılır. */
  function sizeLabel(size) {
    return size === 'Default Title' ? tt('oneSize', 'Tek beden') : size;
  }

  /* PDP'de zaten bir beden seçiliyse mevcut ürünün o varyantını döndür. */
  function preselectedCurrentVariant() {
    var sel = document.querySelector('.size-options.selected-option');
    if (!sel) return null;
    var vid = parseInt(sel.getAttribute('data-id') || sel.getAttribute('data-variant-id'), 10);
    if (!vid) return null;
    var match = CUR.variants.filter(function (v) { return v.id === vid && v.available !== false; })[0];
    return match || null;
  }

  function currentProductVariant(variantId) {
    if (!CUR) return null;
    var id = parseInt(variantId, 10);
    if (!id) return null;
    return CUR.variants.filter(function (variant) {
      return variant.id === id && variant.available !== false;
    })[0] || null;
  }

  /* Builder'ın ilk (PDP) ürünü değişince PDP'nin mevcut beden akışını
     gerçekten tıkla. Böylece yalnız görsel sınıf değil; hidden variant,
     fiyat, URL, stok/BIS ve CTA durumu da tek seferde güncellenir. */
  var suppressPdpCartSync = false;
  function syncPdpVariantSelection(product, variant, syncCart) {
    if (!CUR || !product || !variant || String(product.id) !== String(CUR.id)) return;
    var option = document.querySelector(
      '#size-selection-area a.size-options[data-id="' + String(variant.id) + '"]'
    );
    if (!option || option.classList.contains('out-of-stock')) return;
    if (!option.classList.contains('selected-option')) {
      suppressPdpCartSync = syncCart === false;
      try {
        option.click();
      } finally {
        suppressPdpCartSync = false;
      }
    }
  }

  /* Havuz sırası = KOLEKSİYONUN MANUEL SIRASI.
     Eskiden /collections/<handle>/products.json kullanılıyordu; o uç nokta
     koleksiyonun VARSAYILAN sıralamasını uygular ve sort_by kabul etmez.
     "hoodies" gibi varsayılanı "en çok satanlar" olan koleksiyonlarda bu,
     builder'da renk kardeşleri dağılmış rastgele görünen bir sıra üretiyordu.
     Artık templates/collection.fos-builder.liquid şablonu ?sort_by=manual ile
     okunuyor: sıra, Shopify'da koleksiyonu sürükle-bırak dizdiğiniz sıradır —
     koleksiyon sayfasının kendi varsayılan sıralaması bozulmadan. Zaten manuel
     olan koleksiyonlarda (t-shirts, caps, socks, canta) sonuç değişmez.
     Şablon 50'şerlik sayfalar döndürür; 50'den kalabalık koleksiyonlarda
     kalan sayfalar sırayla eklenir. */
  var BUILDER_VIEW = '?view=fos-builder&sort_by=manual';
  var MAX_POOL_PAGES = 5; // 250 ürün — güvenlik freni

  function builderPageUrl(handle, page) {
    return '/collections/' + handle + BUILDER_VIEW + (page > 1 ? '&page=' + page : '');
  }

  function fetchBuilderPage(handle, page) {
    return window
      .fetch(builderPageUrl(handle, page), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function mapBuilderProduct(p, requiredPrice) {
    // TÜM bedenler taşınır; tükenenler `available:false` ile soluk
    // gösterilir (PDP'deki beden listesiyle tutarlılık).
    var variants = (p.variants || [])
      .map(function (v) {
        return {
          id: v.id,
          size: v.size,
          price: v.price,      // şablon kuruş yazar
          compareAt: v.compareAt || 0,
          available: !!v.available
        };
      })
      .filter(function (v) {
        return requiredPrice === 0 || v.price === requiredPrice;
      });
    var firstAvail = variants.filter(function (v) { return v.available; })[0] || null;
    // Hızlı inceleme katmanı için TÜM görseller + açıklama taşınır
    // (ek istek yok — şablon zaten getiriyor).
    var images = (p.images || []).filter(Boolean);
    return {
      id: p.id,
      handle: p.handle,
      title: p.title,
      image: p.image || images[0] || '',
      images: images,
      desc: p.desc || '',
      price: firstAvail ? firstAvail.price : 0,
      compareAt: firstAvail ? firstAvail.compareAt : 0,
      tags: (p.tags || []).map(function (t) { return String(t).toLowerCase(); }),
      variants: variants
    };
  }

  /* Bir slotun koleksiyonu kasadaki fonksiyonda birden fazla koleksiyondan
     kurulabilir (eskiden hoodie = hoodies + yeni-sezon-hoodie). Liste
     snippets/package-pool.liquid'den window.fosPackagePools ile gelir; sepet
     ve ürün sayfası eşleşmesi de aynı listeyi kullanır. Sıra: önce slotun
     kendi koleksiyonu (manuel sıra), sonra havuzdaki diğerlerinden yeni
     ürünler; aynı ürün bir kez listelenir. */
  function poolHandles(handle) {
    var pools = window.fosPackagePools || {};
    return pools[handle] && pools[handle].length ? pools[handle] : [handle];
  }

  /* Aynı koleksiyon birden çok slotta olabilir (3'lü hoodie: slot 2 ve 3).
     Sonuç değil İSTEK önbelleğe alınır; yoksa ikisi de cache dolmadan
     başlayıp aynı sayfayı iki kez indiriyor. */
  function fetchCollection(handle) {
    if (!handle) return Promise.resolve([]);
    if (collectionCache[handle]) return Promise.resolve(collectionCache[handle]);
    if (inflightCollection[handle]) return inflightCollection[handle];
    var requiredPrice = requiredPriceCents(handle);

    function loadPages(poolHandle) {
      var raw = [];
      function loadPage(page) {
        return fetchBuilderPage(poolHandle, page).then(function (d) {
          raw = raw.concat(d.products || []);
          var pages = parseInt(d.pages, 10) || 1;
          if (page < pages && page < MAX_POOL_PAGES) return loadPage(page + 1);
          return raw;
        });
      }
      return loadPage(1);
    }

    var request = Promise.all(poolHandles(handle).map(loadPages))
      .then(function (lists) {
        var seen = {};
        var list = [];
        lists.forEach(function (products) {
          products.forEach(function (p) {
            if (seen[p.id]) return;
            seen[p.id] = true;
            list.push(p);
          });
        });
        var mapped = list
          .map(function (p) { return mapBuilderProduct(p, requiredPrice); })
          .filter(function (p) {
            return p.variants.some(function (v) { return v.available; });
          });
        collectionCache[handle] = mapped;
        delete inflightCollection[handle];
        return mapped;
      })
      .catch(function (err) {
        delete inflightCollection[handle]; // hata kalıcı olmasın, tekrar denenebilsin
        throw err;
      });
    inflightCollection[handle] = request;
    return request;
  }

  /* exclude_tags (örn. "indirim") taşıyan ürün paketlere GİREMEZ — grid'de
     hiç listelenmez. Eşleşme/sepet katmanları zaten dışlıyor; bu, seçim
     havuzundaki son açık kapıyı kapatır. */
  function eligibleProducts(handle) {
    var cache = collectionCache[handle] || [];
    var excluded = state && state.excludeTags ? state.excludeTags : [];
    if (!excluded.length) return cache;
    return cache.filter(function (p) {
      for (var i = 0; i < excluded.length; i++) {
        if (p.tags.indexOf(excluded[i]) !== -1) return false;
      }
      return true;
    });
  }

  /* ----- modal kabuğu ----- */
  function buildOverlay() {
    overlay = document.createElement('div');
    overlay.className = 'fos-builder';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML =
      '<div class="fos-builder__box" role="dialog" aria-modal="true" aria-label="' + escapeHtml(tt('builderAria', 'Paketini oluştur')) + '">' +
        '<div class="fos-builder__head">' +
          '<div class="fos-builder__title">' + escapeHtml(tt('builderTitle', 'Paketini Oluştur')) + '</div>' +
          '<div class="fos-builder__counter" data-counter></div>' +
          '<button type="button" class="fos-builder__close" aria-label="' + escapeHtml(tt('close', 'Kapat')) + '">&times;</button>' +
        '</div>' +
        '<div class="fos-builder__body" data-acc></div>' +
        '<div class="fos-builder__foot">' +
          '<div class="fos-builder__totals" data-totals></div>' +
          '<button type="button" class="fos-builder__add" data-add disabled>' + escapeHtml(tt('addToCart', 'Sepete Ekle')) + '</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);
    overlay.querySelector('.fos-builder__box').appendChild(qvBuild());

    overlay.addEventListener('click', function (e) {
      if (e.target !== overlay) return;
      // Kademeli çıkış: hızlı inceleme açıksa önce o kapanır, paket durmaz.
      if (qvIsOpen()) {
        closeQuickView();
        return;
      }
      closeBuilder();
    });
    overlay.querySelector('.fos-builder__close').addEventListener('click', closeBuilder);
    overlay.querySelector('[data-add]').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      addToCart();
    });
  }

  /* opts iki biçimde gelebilir:
     1) Volume (eski/mevcut): { qty, totalCents, collection (handle), locked: [{product, variant, inCart}] }
        — tüm slotlar AYNI koleksiyondan.
     2) Combo/heterojen (Faz B): { totalCents, packageHandle, slots: [{ collection, locked: {product, variant, inCart} }] }
        — her slot KENDİ koleksiyonundan (Daily Fit: t-shirts + caps; Full Fit: hoodie+tee+cap; Space Bag: çanta+cap+tee).
     locked: önceden dolu/kilitli slot. inCart=true ise zaten sepette →
     "Sepete Ekle"de TEKRAR eklenmez (yalnız yeni seçilenler eklenir). */
  function normalizeSlots(opts) {
    if (opts.slots) {
      return opts.slots.map(function (s) {
        var lock = s.locked;
        return {
          collection: s.collection || null,
          product: lock ? lock.product : null,
          variant: lock ? (lock.variant || null) : null,
          locked: !!lock,
          inCart: lock ? !!lock.inCart : false
        };
      });
    }
    var slots = [];
    (opts.locked || []).forEach(function (l) {
      slots.push({ collection: opts.collection || COLLECTION, product: l.product, variant: l.variant || null, locked: true, inCart: !!l.inCart });
    });
    while (slots.length < opts.qty) {
      slots.push({ collection: opts.collection || COLLECTION, product: null, variant: null, locked: false, inCart: false });
    }
    return slots;
  }

  function cloneLock(lock) {
    if (!lock) return null;
    return {
      product: lock.product,
      variant: lock.variant || null,
      inCart: !!lock.inCart
    };
  }

  function cloneOpenOptions(opts) {
    var copy = {};
    Object.keys(opts || {}).forEach(function (key) {
      copy[key] = opts[key];
    });
    if (opts && opts.locked) {
      copy.locked = opts.locked.map(cloneLock);
    }
    if (opts && opts.slots) {
      copy.slots = opts.slots.map(function (slot) {
        return {
          collection: slot.collection || null,
          locked: cloneLock(slot.locked)
        };
      });
    }
    copy.resumeFromCart = false;
    return copy;
  }

  function packageKeyFor(opts) {
    var handle = opts.packageHandle || '';
    if (!handle) return '';
    var shape = opts.slots
      ? opts.slots.map(function (slot) { return slot.collection || ''; }).join('+')
      : String(opts.collection || COLLECTION || '') + 'x' + String(opts.qty || 0);
    var pricing = opts.freeQuantity > 0
      ? 'free-' + String(opts.freeQuantity)
      : String(opts.totalCents || 0);
    return ['fos-v1', handle, shape, pricing].join(':');
  }

  /* Aynı deterministik paket anahtarında tamamlanmış grupları koruyup yalnız
     yarım paketin hedef slotundaki ilk fazla birimi döndürür. */
  function partialPackageUnit(cart, packageKey, qty, targetSlot) {
    var bySlot = [];
    for (var slotIndex = 0; slotIndex < qty; slotIndex++) bySlot.push([]);

    (cart.items || []).forEach(function (line) {
      if (!line.properties || line.properties._fos_package_key !== packageKey) return;
      var slot = parseInt(line.properties._fos_package_slot, 10);
      if (slot < 0 || slot >= qty || !line.key) return;
      var quantity = parseInt(line.quantity, 10) || 0;
      for (var unitIndex = 0; unitIndex < quantity; unitIndex++) {
        bySlot[slot].push({ line: line, unitIndex: unitIndex });
      }
    });

    if (!bySlot.length) return null;
    var completedGroups = Math.min.apply(
      null,
      bySlot.map(function (units) { return units.length; })
    );
    var partialUnits = bySlot[targetSlot].slice(
      0,
      Math.max(0, bySlot[targetSlot].length - completedGroups)
    );
    return partialUnits[0] || null;
  }

  function packageVariantLine(cart, packageKey, slot, variantId) {
    return (cart.items || []).filter(function (line) {
      return (
        line.key &&
        String(line.variant_id) === String(variantId) &&
        line.properties &&
        line.properties._fos_package_key === packageKey &&
        String(line.properties._fos_package_slot) === String(slot)
      );
    })[0] || null;
  }

  function updateCartLine(lineKey, quantity) {
    var updates = {};
    updates[lineKey] = quantity;
    return window
      .fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      });
  }

  function addCartItem(item) {
    return window
      .fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error('Cart add failed');
          return data;
        });
      });
  }

  var pendingPdpSyncSignature = '';

  /* PDP bedeni yarım paketin sepetteki slot-0 bedeniyle çakışıyorsa PDP'yi
     otorite kabul et: yeni varyantı aynı özel paket özellikleriyle ekle,
     ardından eski keyed satırdan yalnız bir birim eksilt. Tüm yazımlar seri
     gider; ikinci adım başarısız olursa yeni eklenen birimi geri alırız. */
  function syncPartialPdpVariant(variant, opts) {
    if (!variant || !opts || opts.qty <= 1) return pendingCartWrite;
    var packageKey = opts.packageKey || packageKeyFor(opts);
    if (!packageKey) return pendingCartWrite;
    var signature = packageKey + ':' + String(variant.id);
    if (pendingPdpSyncSignature === signature) return pendingCartWrite;
    pendingPdpSyncSignature = signature;

    pendingCartWrite = pendingCartWrite
      .then(function () {
        return window
          .fetch('/cart.js', {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart unavailable');
            return response.json();
          });
      })
      .then(function (cart) {
        var unit = partialPackageUnit(cart, packageKey, opts.qty, 0);
        if (!unit || String(unit.line.variant_id) === String(variant.id)) return null;

        var oldLine = unit.line;
        var properties = oldLine.properties || {
          _fos_package_key: packageKey,
          _fos_package_slot: '0'
        };
        var replacement = { id: variant.id, quantity: 1, properties: properties };
        var previousReplacementLine = packageVariantLine(cart, packageKey, 0, variant.id);
        var previousReplacementQuantity = previousReplacementLine
          ? parseInt(previousReplacementLine.quantity, 10) || 0
          : 0;
        var replacementKey = previousReplacementLine && previousReplacementLine.key;

        return addCartItem(replacement)
          .then(function (addResult) {
            var addedLine = addResult && addResult.items && addResult.items[0];
            replacementKey = replacementKey || (addedLine && addedLine.key);
            return updateCartLine(
              oldLine.key,
              Math.max(0, (parseInt(oldLine.quantity, 10) || 1) - 1)
            ).then(function () {
              return addResult;
            });
          })
          .catch(function (error) {
            if (!replacementKey) throw error;
            return updateCartLine(replacementKey, previousReplacementQuantity).then(
              function () { throw error; },
              function () { throw error; }
            );
          });
      })
      .then(function (result) {
        if (result) {
          document.dispatchEvent(new CustomEvent('cart:itemAdded', { detail: result }));
          refreshCartSilently();
        }
      })
      .catch(function () {
        refreshCartSilently();
        showToast(tt('partialAddFail', 'Sepete eklenemedi, tekrar deneyin.'), { error: true });
      })
      .then(function () {
        if (pendingPdpSyncSignature === signature) pendingPdpSyncSignature = '';
      });

    return pendingCartWrite;
  }

  function resumePool(handle, excludeTags) {
    var excluded = (excludeTags || []).map(function (tag) {
      return String(tag).toLowerCase();
    });
    return (collectionCache[handle] || []).filter(function (product) {
      return !excluded.some(function (tag) {
        return product.tags.indexOf(tag) !== -1;
      });
    });
  }

  function cartUnitsBySlot(cart, slotHandles, excludeTags, packageKey) {
    var bySlot = slotHandles.map(function (handle, slotIndex) {
      var products = {};
      resumePool(handle, excludeTags).forEach(function (product) {
        products[product.id] = product;
      });
      var units = [];
      (cart.items || []).forEach(function (line) {
        if (!packageKey || !line.properties || line.properties._fos_package_key !== packageKey) return;
        if (String(line.properties._fos_package_slot) !== String(slotIndex)) return;
        var product = products[line.product_id];
        if (!product) return;
        var variant = product.variants.filter(function (candidate) {
          return candidate.id === line.variant_id;
        })[0];
        if (!variant) return;
        for (var i = 0; i < line.quantity; i++) {
          units.push({
            key: String(line.key || line.variant_id) + ':' + i,
            product: product,
            variant: variant
          });
        }
      });
      return units;
    });
    if (!bySlot.length) return bySlot;
    var completedGroups = Math.min.apply(
      null,
      bySlot.map(function (units) { return units.length; })
    );
    if (!completedGroups) return bySlot;
    return bySlot.map(function (units) {
      return units.slice(0, Math.max(0, units.length - completedGroups));
    });
  }

  function hydrateFromCart(opts) {
    var hydrated = cloneOpenOptions(opts);
    hydrated.packageKey = hydrated.packageKey || packageKeyFor(hydrated);
    var slotHandles = [];
    if (hydrated.slots) {
      hydrated.slots.forEach(function (slot) {
        slotHandles.push(slot.collection || '');
      });
    } else if (hydrated.collection) {
      for (var slotIndex = 0; slotIndex < hydrated.qty; slotIndex++) {
        slotHandles.push(hydrated.collection);
      }
    }
    if (!slotHandles.length) return window.Promise.resolve(hydrated);
    var handles = slotHandles.filter(function (handle, index, all) {
      return handle && all.indexOf(handle) === index;
    });

    return pendingCartWrite
      .then(function () {
        return window.Promise.all([
          window.fetch('/cart.js', {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          }).then(function (response) {
            if (!response.ok) throw new Error('Cart unavailable');
            return response.json();
          }),
          window.Promise.all(handles.map(fetchCollection))
        ]);
      })
      .then(function (results) {
        var unitsBySlot = cartUnitsBySlot(
          results[0],
          slotHandles,
          hydrated.excludeTags || [],
          hydrated.packageKey
        );
        var originalSlots = hydrated.slots || slotHandles.map(function (handle, index) {
          return {
            collection: handle,
            locked: hydrated.locked && hydrated.locked[index]
          };
        });
        hydrated.slots = originalSlots.map(function (slot, index) {
          var unit = unitsBySlot[index] && unitsBySlot[index][0];
          return {
            collection: slot.collection,
            locked: unit
              ? { product: unit.product, variant: unit.variant, inCart: true }
              : cloneLock(slot.locked)
          };
        });

        return hydrated;
      });
  }

  function openBuilder(opts) {
    opts = opts || {};
    var request = ++openRequest;
    if (!opts.resumeFromCart) {
      openBuilderReady(opts);
      return;
    }
    hydrateFromCart(opts)
      .then(function (hydrated) {
        if (request === openRequest) openBuilderReady(hydrated);
      })
      .catch(function () {
        if (request === openRequest) openBuilderReady(cloneOpenOptions(opts));
      });
  }

  function openBuilderReady(opts) {
    if (!overlay) buildOverlay();
    closeQuickView(true); // yeni paket → önceki incelemenin izi kalmasın
    var slots = normalizeSlots(opts);
    state = {
      qty: slots.length,
      totalCents: opts.totalCents || 0,
      // >0 ise paketin sabit fiyatı yoktur: en ucuz `freeQuantity` parça
      // bizden, toplam seçilen ürünlerden canlı hesaplanır.
      freeQuantity: parseInt(opts.freeQuantity, 10) || 0,
      packageKey: opts.packageKey || packageKeyFor(opts),
      packageHandle: opts.packageHandle || '',
      source: opts.source || '',
      excludeTags: (opts.excludeTags || []).map(function (t) { return String(t).toLowerCase(); }),
      slots: slots,
      active: null,
      accEls: [],
      // kullanıcı modalda gerçekten bir seçim yaptı mı? (yalnız o zaman
      // yarım kapanışta sepete akıtılır — "aç-kapa" kazara ekleme yapmaz)
      touched: false
    };
    state.active = firstIncomplete();
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    buildStructure();
    if (state.slots[0]) {
      syncPdpVariantSelection(state.slots[0].product, state.slots[0].variant, false);
    }
    updateTotals();

    var handles = [];
    state.slots.forEach(function (s) {
      if (!s.locked && s.collection && handles.indexOf(s.collection) === -1) handles.push(s.collection);
    });
    Promise.all(handles.map(fetchCollection)).then(populateGrids).catch(populateGrids);
  }

  /* Modalı yalnız kapat (sepete dokunmaz) — başarılı "Sepete Ekle" sonrası. */
  function dismissBuilder() {
    if (!overlay) return;
    if (state) state.touched = false;
    closeQuickView(true);
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* Kullanıcı kapatınca (X / dışına tıkla / Esc): paket yarım kalsa bile
     seçtikleri kaybolmasın — sepete ekle, küçük toast ile haber ver. */
  function closeBuilder() {
    if (state && state.source === 'pdp') {
      document.dispatchEvent(new CustomEvent('fos:pdp-package-builder-closed', {
        detail: {
          packageHandle: state.packageHandle,
          filled: filledCount(),
          total: state.qty
        }
      }));
    }
    flushSelections();
    dismissBuilder();
  }

  /* Sepete akıtılacak satırlar: dolu slotlar, sepette OLANLAR hariç.
     Her slot gizli paket/slot anahtarını ayrı taşır; böylece tekrar açılışta
     yalnız bu yarım paketin doğru ürünleri ve doğru yuvaları geri gelir. */
  function pendingItems() {
    var items = [];
    state.slots.forEach(function (s, index) {
      if (!s.variant || s.inCart) return;
      var item = { id: s.variant.id, quantity: 1 };
      if (state.packageKey) {
        item.properties = {
          _fos_package_key: state.packageKey,
          _fos_package_slot: String(index)
        };
      }
      items.push(item);
    });
    return items;
  }

  function flushSelections() {
    if (!state || !state.touched) return;
    var items = pendingItems();
    state.touched = false; // çift ekleme koruması
    if (!items.length) return;
    var count = items.reduce(function (n, it) { return n + it.quantity; }, 0);

    pendingCartWrite = pendingCartWrite
      .then(function () {
        return window.fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          showToast(tt('partialAddFail', 'Sepete eklenemedi, tekrar deneyin.'), { error: true });
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:itemAdded', { detail: res.data }));
        refreshCartSilently();
        showToast(tt('partialAdded', '__N__ ürün sepete eklendi', { N: count }), {
          cta: tt('viewCart', 'Sepeti gör')
        });
      })
      .catch(function () {
        showToast(tt('partialAddFail', 'Sepete eklenemedi, tekrar deneyin.'), { error: true });
      });
    return pendingCartWrite;
  }

  /* ----- durum yardımcıları ----- */
  function firstIncomplete() {
    for (var i = 0; i < state.slots.length; i++) {
      if (!state.slots[i].variant) return i;
    }
    return null;
  }
  function filledCount() {
    return state.slots.filter(function (s) { return s.variant; }).length;
  }
  /* Sayaç için "dolu" = slotta ÜRÜN var (beden sonra tamamlanabilir).
     PDP'den açılışta 1. slot mevcut ürünle dolu → sayaç 1/N başlar. */
  function occupiedCount() {
    return state.slots.filter(function (s) { return s.product; }).length;
  }

  function setActive(i) {
    state.active = i;
    state.accEls.forEach(function (e, idx) {
      e.acc.classList.toggle('is-open', state.active === idx);
      e.acc.classList.toggle('is-done', !!state.slots[idx].variant);
      e.acc.classList.toggle('is-empty', !state.slots[idx].product);
      e.head.setAttribute('aria-expanded', state.active === idx ? 'true' : 'false');
    });
  }

  function focusAddWithoutScroll() {
    if (!overlay || overlay.getAttribute('aria-hidden') !== 'false') return;
    var add = overlay.querySelector('[data-add]');
    if (!add || add.disabled) return;
    try { add.focus({ preventScroll: true }); } catch (e) { add.focus(); }
  }

  function pickSize(i, product, variant) {
    state.slots[i].product = product;
    state.slots[i].variant = variant;
    state.touched = true;
    state.accEls[i].head.innerHTML = accHeadHtml(state.slots[i], i);
    if (i === 0) syncPdpVariantSelection(product, variant);
    setActive(firstIncomplete()); // sıradaki eksik slotu aç (yoksa null = hepsi kapanır)
    updateTotals();
    if (filledCount() === state.qty) {
      window.requestAnimationFrame(focusAddWithoutScroll);
    }
  }

  /* ----- beden butonları (tükenenler soluk/çizili, seçilemez) ----- */
  function sizeRow(product, onPick, selectedVariant) {
    var s = document.createElement('span');
    s.className = 'fos-builder__sizes';
    product.variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fos-builder__size';
      b.textContent = sizeLabel(v.size);
      if (v.available === false) {
        b.classList.add('is-soldout');
        b.disabled = true;
        b.setAttribute('aria-label', tt('sizeSoldOut', '__SIZE__ — tükendi', { SIZE: v.size }));
      } else {
        var selected = !!(selectedVariant && String(selectedVariant.id) === String(v.id));
        b.classList.toggle('is-selected', selected);
        b.setAttribute('aria-pressed', selected ? 'true' : 'false');
        b.addEventListener('click', function (e) {
          e.stopPropagation();
          s.querySelectorAll('.fos-builder__size:not(:disabled)').forEach(function (option) {
            var on = option === b;
            option.classList.toggle('is-selected', on);
            option.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          onPick(v);
        });
      }
      s.appendChild(b);
    });
    return s;
  }

  /* ============================================================
     Hızlı inceleme (quick view)
     ------------------------------------------------------------
     Grid'deki ürün görseline tıklanınca AYNI modalın içinde sağdan
     kayan bir detay katmanı açılır — kullanıcı ürünü incelemek için
     akıştan (ve paketten) çıkmaz. Katman modal kutusunun içinde
     absolute durur; altındaki akordiyon yapısı hiç bozulmaz, geri
     dönünce kaldığı yerden devam eder.
     İçerik: kaydırmalı galeri (tıkla-yakınlaştır), başlık, fiyat,
     açıklama, beden seçimi ve "Paketine ekle" — seçim doğrudan o
     slotu doldurur, katman kapanır, sıradaki slot açılır.
     ============================================================ */
  var qvEl = null;
  var qv = null; // { slot, product, variant, index, count, trigger }

  var ZOOM_ICON =
    '<svg class="fos-ico" viewBox="0 0 12 12" aria-hidden="true" focusable="false">' +
      '<circle cx="5" cy="5" r="3.4" fill="none" stroke="currentColor" stroke-width="1.4"/>' +
      '<path d="M7.7 7.7 11 11" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>' +
    '</svg>';

  function qvBuild() {
    qvEl = document.createElement('div');
    qvEl.className = 'fos-qv';
    qvEl.setAttribute('aria-hidden', 'true');
    qvEl.setAttribute('role', 'dialog');
    qvEl.setAttribute('aria-modal', 'true');
    qvEl.setAttribute('aria-label', tt('qvAria', 'Ürün detayı'));
    qvEl.innerHTML =
      '<div class="fos-qv__head">' +
        '<button type="button" class="fos-qv__back" data-qv-back>' +
          '<span class="fos-qv__back-ico" aria-hidden="true"></span>' +
          '<span>' + escapeHtml(tt('qvBack', 'Geri')) + '</span>' +
        '</button>' +
        '<span class="fos-qv__slotlabel" data-qv-slot lang="en"></span>' +
      '</div>' +
      '<div class="fos-qv__body" data-qv-body></div>' +
      // Beden seçimi alt barda sabit durur: kullanıcı galeriyi/açıklamayı
      // ne kadar kaydırırsa kaydırsın asıl karar düğmesi hep ekranda.
      '<div class="fos-qv__foot">' +
        '<div class="fos-qv__sizebar">' +
          '<span class="fos-qv__sizes-head">' + escapeHtml(tt('selectSize', 'Beden seç')) + '</span>' +
          '<div class="fos-qv__sizes" data-qv-sizes></div>' +
        '</div>' +
        '<div class="fos-qv__foot-row">' +
          '<div class="fos-qv__price" data-qv-price></div>' +
          '<button type="button" class="fos-qv__cta" data-qv-cta disabled></button>' +
        '</div>' +
      '</div>';

    qvEl.querySelector('[data-qv-back]').addEventListener('click', closeQuickView);
    qvEl.querySelector('[data-qv-cta]').addEventListener('click', qvCommit);
    return qvEl;
  }

  /* Katman açıkken alttaki builder klavye/ekran okuyucu için devre dışı. */
  function qvSetUnderlayInert(on) {
    if (!overlay) return;
    ['.fos-builder__head', '.fos-builder__body', '.fos-builder__foot'].forEach(function (sel) {
      var el = overlay.querySelector(sel);
      if (el && 'inert' in el) el.inert = on;
    });
  }

  function openQuickView(slotIndex, product, trigger) {
    if (!qvEl || !product) return;
    var slot = state.slots[slotIndex];
    // Aynı ürün bu slotta zaten seçiliyse bedeni işaretli gelsin.
    var pre = slot && slot.variant && slot.product && slot.product.id === product.id ? slot.variant : null;
    if (!pre) {
      var avail = product.variants.filter(function (v) { return v.available !== false; });
      if (avail.length === 1) pre = avail[0]; // tek beden → tek dokunuşla eklenebilsin
    }
    qv = {
      slot: slotIndex,
      product: product,
      variant: pre,
      index: 0,
      count: 0,
      trigger: trigger || null
    };
    qvRender();
    qvEl.setAttribute('aria-hidden', 'false');
    overlay.querySelector('.fos-builder__box').classList.add('is-qv');
    qvSetUnderlayInert(true);
    var back = qvEl.querySelector('[data-qv-back]');
    if (back) back.focus({ preventScroll: true });
  }

  function closeQuickView(instant, restoreFocus) {
    if (!qvEl || !qv) return;
    var trigger = qv.trigger;
    qv = null;
    qvEl.setAttribute('aria-hidden', 'true');
    if (instant === true) qvEl.classList.add('is-instant');
    qvSetUnderlayInert(false);
    var box = overlay && overlay.querySelector('.fos-builder__box');
    if (box) box.classList.remove('is-qv');
    if (instant === true) {
      // kutu kapanıyor: geçişi atla, bir sonraki açılışta tekrar animasyonlu
      void qvEl.offsetWidth;
      qvEl.classList.remove('is-instant');
      return;
    }
    if (restoreFocus !== false && trigger && document.contains(trigger)) {
      trigger.focus({ preventScroll: true });
    }
  }

  function qvIsOpen() {
    return !!(qvEl && qv && qvEl.getAttribute('aria-hidden') === 'false');
  }

  function qvRender() {
    var p = qv.product;
    var imgs = (p.images && p.images.length ? p.images : p.image ? [p.image] : []).slice(0, 8);
    qv.count = imgs.length;

    var slots = state.slots;
    var slotLabel = tt('qvSlot', '__N__. __NOUN__', {
      N: qv.slot + 1,
      NOUN: slotNoun(slots[qv.slot] ? slots[qv.slot].collection : null)
    });
    qvEl.querySelector('[data-qv-slot]').textContent = slotLabel;

    var slidesHtml = imgs
      .map(function (src, n) {
        return (
          '<div class="fos-qv__slide" data-qv-slide="' + n + '">' +
            '<img src="' + escapeHtml(imgUrl(src, 900)) + '" alt="' + escapeHtml(p.title) + '"' +
              (n ? ' loading="lazy"' : '') + ' draggable="false">' +
          '</div>'
        );
      })
      .join('');

    var dotsHtml = imgs.length > 1
      ? imgs
          .map(function (_, n) {
            return (
              '<button type="button" class="fos-qv__dot' + (n === 0 ? ' is-on' : '') + '"' +
                ' data-qv-dot="' + n + '" aria-label="' +
                escapeHtml(tt('imageN', 'Görsel __N__', { N: n + 1 })) + '"></button>'
            );
          })
          .join('')
      : '';

    var navHtml = imgs.length > 1
      ? '<button type="button" class="fos-qv__nav is-prev" data-qv-prev aria-label="' + escapeHtml(tt('qvPrev', 'Önceki')) + '"></button>' +
        '<button type="button" class="fos-qv__nav is-next" data-qv-next aria-label="' + escapeHtml(tt('qvNext', 'Sonraki')) + '"></button>'
      : '';

    var galleryHtml = imgs.length
      ? '<div class="fos-qv__gallery" data-qv-gal>' +
          '<div class="fos-qv__track" data-qv-track>' + slidesHtml + '</div>' +
          navHtml +
          '<span class="fos-qv__hint" data-qv-hint>' + ZOOM_ICON + escapeHtml(tt('qvZoomHint', 'Büyütmek için dokun')) + '</span>' +
          (dotsHtml ? '<div class="fos-qv__dots">' + dotsHtml + '</div>' : '') +
        '</div>'
      : '';

    var descHtml = p.desc
      ? '<p class="fos-qv__desc" data-qv-desc>' + escapeHtml(p.desc) + '</p>' +
        '<button type="button" class="fos-qv__more" data-qv-more hidden>' + escapeHtml(tt('qvMore', 'Devamını oku')) + '</button>'
      : '';

    var linkHtml = p.handle
      ? '<a class="fos-qv__link" href="/products/' + encodeURIComponent(p.handle) + '" target="_blank" rel="noopener">' +
          escapeHtml(tt('qvProductPage', 'Ürün sayfası')) +
          '<span class="fos-qv__link-ico" aria-hidden="true"></span>' +
        '</a>'
      : '';

    qvEl.querySelector('[data-qv-body]').innerHTML =
      galleryHtml +
      '<div class="fos-qv__info">' +
        '<h3 class="fos-qv__title">' + escapeHtml(p.title) + '</h3>' +
        '<div class="fos-qv__meta">' +
          '<span class="fos-qv__incl">' + escapeHtml(tt('qvIncluded', 'Paket fiyatına dahil')) + '</span>' +
          linkHtml +
        '</div>' +
        descHtml +
      '</div>';

    qvRenderSizes();
    qvBindGallery();
    qvBindDesc();
    qvUpdateFoot();
  }

  /* Beden seçimi burada ANINDA slotu doldurmaz: kullanıcı seçtiğini görsün,
     onayı alt bardaki tek CTA versin (yanlış dokunuşla akış zıplamasın). */
  function qvRenderSizes() {
    var wrap = qvEl.querySelector('[data-qv-sizes]');
    wrap.innerHTML = '';
    qv.product.variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fos-qv__size';
      b.textContent = sizeLabel(v.size);
      if (v.available === false) {
        b.classList.add('is-soldout');
        b.disabled = true;
        b.setAttribute('aria-label', tt('sizeSoldOut', '__SIZE__ — tükendi', { SIZE: v.size }));
      } else {
        if (qv.variant && qv.variant.id === v.id) b.classList.add('is-on');
        b.setAttribute('aria-pressed', qv.variant && qv.variant.id === v.id ? 'true' : 'false');
        b.addEventListener('click', function () {
          qv.variant = v;
          wrap.querySelectorAll('.fos-qv__size').forEach(function (o) {
            o.classList.toggle('is-on', o === b);
            if (!o.disabled) o.setAttribute('aria-pressed', o === b ? 'true' : 'false');
          });
          qvUpdateFoot();
        });
      }
      wrap.appendChild(b);
    });
  }

  function qvUpdateFoot() {
    var v = qv.variant;
    var price = v ? v.price : qv.product.price || 0;
    var cmp = v ? v.compareAt : qv.product.compareAt;
    var html = '<span class="fos-qv__price-val">' + money(price) + '</span>';
    if (cmp && cmp > price) html += '<span class="fos-qv__price-cmp">' + money(cmp) + '</span>';
    qvEl.querySelector('[data-qv-price]').innerHTML = html;

    var cta = qvEl.querySelector('[data-qv-cta]');
    cta.classList.remove('is-done');
    cta.disabled = !v;
    cta.textContent = v ? tt('qvAdd', 'Paketine ekle') : tt('selectSize', 'Beden seç');
  }

  /* Uzun açıklama 4 satırda kırpılır; SADECE gerçekten taşıyorsa
     "Devamını oku" belirir. Ölçüm katman görünür olduktan (ve yazı tipi
     yerleştikten) sonra yapılır — erken ölçüm yanlış sonuç veriyor. */
  function qvBindDesc() {
    var desc = qvEl.querySelector('[data-qv-desc]');
    var more = qvEl.querySelector('[data-qv-more]');
    if (!desc || !more) return;
    more.addEventListener('click', function () {
      var open = desc.classList.toggle('is-open');
      more.textContent = open ? tt('qvLess', 'Daha az göster') : tt('qvMore', 'Devamını oku');
    });
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (!qv || !document.contains(desc)) return;
        more.hidden = desc.scrollHeight - desc.clientHeight <= 2;
      });
    });
  }

  /* Galeri: yatay scroll-snap (mobilde doğal kaydırma), ok/nokta ile
     yumuşak geçiş, görsele tıkla-yakınlaştır (imleçle gezinme). */
  function qvBindGallery() {
    var gal = qvEl.querySelector('[data-qv-gal]');
    if (!gal) return;
    var track = gal.querySelector('[data-qv-track]');
    var dots = gal.querySelectorAll('[data-qv-dot]');

    var slides = gal.querySelectorAll('.fos-qv__slide');

    /* Komşu kareleri şimdiden yükle: kaydırınca boş kutu görünmesin
       (uzaktakiler lazy kalır — 8 büyük görsel peşin inmez). */
    function ensureLoaded(n) {
      [n - 1, n, n + 1].forEach(function (k) {
        if (k < 0 || k >= slides.length) return;
        var im = slides[k].querySelector('img');
        if (im && im.loading === 'lazy') im.loading = 'eager';
      });
    }

    function setIndex(n) {
      qv.index = Math.max(0, Math.min(qv.count - 1, n));
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === qv.index); });
      ensureLoaded(qv.index);
    }

    ensureLoaded(0);
    // Nokta senkronu doğrudan scroll'da (rAF sekmesi gizliyken durabiliyor).
    track.addEventListener('scroll', function () {
      if (!qv || !track.clientWidth) return;
      setIndex(Math.round(track.scrollLeft / track.clientWidth));
    });

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        qvGoto(parseInt(d.getAttribute('data-qv-dot'), 10));
      });
    });
    var prev = gal.querySelector('[data-qv-prev]');
    var next = gal.querySelector('[data-qv-next]');
    if (prev) prev.addEventListener('click', function () { qvGoto(qv.index - 1); });
    if (next) next.addEventListener('click', function () { qvGoto(qv.index + 1); });

    gal.querySelectorAll('.fos-qv__slide').forEach(function (slide) {
      slide.addEventListener('click', function (e) {
        var on = !slide.classList.contains('is-zoomed');
        qvClearZoom();
        if (on) {
          slide.classList.add('is-zoomed');
          gal.classList.add('has-zoom');
          qvZoomOrigin(slide, e);
        }
      });
      slide.addEventListener('pointermove', function (e) {
        if (slide.classList.contains('is-zoomed')) qvZoomOrigin(slide, e);
      });
    });
  }

  function qvZoomOrigin(slide, e) {
    var img = slide.querySelector('img');
    if (!img) return;
    var r = slide.getBoundingClientRect();
    var x = Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100));
    var y = Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100));
    img.style.setProperty('--zx', x + '%');
    img.style.setProperty('--zy', y + '%');
  }

  function qvClearZoom() {
    if (!qvEl) return;
    var gal = qvEl.querySelector('[data-qv-gal]');
    if (!gal) return;
    gal.classList.remove('has-zoom');
    gal.querySelectorAll('.fos-qv__slide.is-zoomed').forEach(function (s) {
      s.classList.remove('is-zoomed');
    });
  }

  function qvGoto(n) {
    var track = qvEl.querySelector('[data-qv-track]');
    if (!track || !qv) return;
    qvClearZoom();
    var idx = Math.max(0, Math.min(qv.count - 1, n));
    track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
  }

  /* CTA: seçimi slota yaz. Önce katman kayarak kapanır, akordiyon
     güncellemesi kapanış bitince yapılır — kutu yüksekliği katman
     ekrandayken değişmediği için geçiş tek ve pürüzsüz görünür. */
  function qvCommit() {
    if (!qv || !qv.variant) return;
    var i = qv.slot;
    var p = qv.product;
    var v = qv.variant;
    var cta = qvEl.querySelector('[data-qv-cta]');
    cta.classList.add('is-done');
    cta.textContent = tt('qvAdded', 'Eklendi');
    cta.disabled = true;
    pickSize(i, p, v);
    closeQuickView(false, false);
  }

  /* ----- akordiyon başlığı ----- */
  function accHeadHtml(slot, i) {
    var num = '<span class="fos-builder__acc-num">' + (i + 1) + '</span>';
    var chev = '<span class="fos-builder__acc-chev" aria-hidden="true"></span>';
    var tag = slot.locked
      ? ' <em class="fos-builder__tag">' + escapeHtml(slot.inCart ? tt('inCart', 'sepette') : tt('thisItem', 'bu ürün')) + '</em>'
      : '';
    var thumb = slot.product && slot.product.image
      ? '<span class="fos-builder__acc-thumb"><img src="' + slot.product.image + '" alt=""></span>'
      : '';
    var label;

    if (slot.variant) {
      label =
        '<span class="fos-builder__acc-label">' +
          '<span class="fos-builder__acc-title">' + escapeHtml(slot.product.title) + tag + '</span>' +
          '<span class="fos-builder__acc-size">' + escapeHtml(tt('sizeLabel', 'Beden: __SIZE__', { SIZE: sizeLabel(slot.variant.size) })) + '</span>' +
        '</span>';
    } else if (slot.locked) {
      // tek ve GÖRÜNÜR "Beden seç" uyarısı (gövdede tekrar edilmez)
      label =
        '<span class="fos-builder__acc-label">' +
          '<span class="fos-builder__acc-title">' + escapeHtml(slot.product.title) + tag + '</span>' +
          '<span class="fos-builder__acc-hint is-warn">' + escapeHtml(tt('selectSize', 'Beden seç')) + '</span>' +
        '</span>';
    } else {
      // boş slot: "+" öneki + ipucu — tıklanabilirlik belli olsun
      label =
        '<span class="fos-builder__acc-label">' +
          '<span class="fos-builder__acc-title">' + escapeHtml(tt('slotPick', '__NOUN__ Seç', { NOUN: slotNounTitle(slot.collection) })) + '</span>' +
          '<span class="fos-builder__acc-hint">' + escapeHtml(tt('tapToPick', 'Seçmek için tıkla')) + '</span>' +
        '</span>';
    }
    return num + thumb + label + chev;
  }

  /* Kişi kişi paketler (Kış Ekibi): slot dizisi kısa bir desenin tekrarıysa
     ([hoodie, kazak, şapka] × 3) desen uzunluğu bir kişinin parça sayısıdır.
     Tekrar yoksa 0 → gruplama yok. package-kasim-card.liquid kişi başı
     fiyatı aynı çıkarımla hesaplar. */
  function inferGroupSize(slots) {
    var n = slots.length;
    for (var period = 2; period < n; period++) {
      if (n % period !== 0) continue;
      var repeats = true;
      for (var i = period; i < n; i++) {
        if (slots[i].collection !== slots[i % period].collection) {
          repeats = false;
          break;
        }
      }
      if (repeats) return period;
    }
    return 0;
  }

  /* ----- yapı (bir kez) ----- */
  function buildStructure() {
    var container = overlay.querySelector('[data-acc]');
    container.innerHTML = '';
    state.accEls = [];

    var groupSize = inferGroupSize(state.slots);

    state.slots.forEach(function (slot, i) {
      if (groupSize && i % groupSize === 0) {
        var group = document.createElement('div');
        group.className = 'fos-builder__group';
        group.textContent = tt('groupPerson', '__N__. KİŞİ', { N: i / groupSize + 1 });
        container.appendChild(group);
      }

      var acc = document.createElement('div');
      acc.className = 'fos-builder__acc';

      var head = document.createElement('button');
      head.type = 'button';
      head.className = 'fos-builder__acc-head';
      head.innerHTML = accHeadHtml(slot, i);
      head.addEventListener('click', function () {
        setActive(state.active === i ? null : i);
      });

      var wrap = document.createElement('div');
      wrap.className = 'fos-builder__acc-wrap';
      var body = document.createElement('div');
      body.className = 'fos-builder__acc-body';

      if (slot.locked) {
        var only = document.createElement('div');
        only.className = 'fos-builder__only';
        var editablePdpSlot = !!(
          DATA &&
          i === 0 &&
          CUR &&
          slot.product &&
          String(slot.product.id) === String(CUR.id)
        );
        if (
          (!slot.inCart || editablePdpSlot) &&
          slot.product &&
          slot.product.variants &&
          slot.product.variants.length
        ) {
          // PDP: mevcut ürün — beden seçilebilir/değiştirilebilir.
          // "Beden seç" uyarısı yalnız akordiyon başlığında (çift metin olmasın).
          only.appendChild(sizeRow(
            slot.product,
            function (v) { pickSize(i, slot.product, v); },
            slot.variant
          ));
        } else {
          // Sepetten kilitli — beden zaten belli, değiştirilemez
          only.innerHTML = '<span class="fos-builder__only-hint">' +
            escapeHtml(tt('lockedInCart', 'Sepette ekli — beden: __SIZE__', { SIZE: slot.variant ? sizeLabel(slot.variant.size) : '' })) + '</span>';
        }
        body.appendChild(only);
      } else {
        var grid = document.createElement('div');
        grid.className = 'fos-builder__grid';
        grid.innerHTML = '<div class="fos-builder__loading">' + escapeHtml(tt('loading', 'Yükleniyor…')) + '</div>';
        body.appendChild(grid);
      }

      wrap.appendChild(body);
      acc.appendChild(head);
      acc.appendChild(wrap);
      container.appendChild(acc);
      state.accEls.push({ acc: acc, head: head, body: body });
    });

    setActive(state.active);
  }

  /* ----- grid'leri doldur (koleksiyon yüklenince) ----- */
  function populateGrids() {
    if (!state || !overlay) return;
    state.slots.forEach(function (slot, i) {
      if (slot.locked) return;
      var grid = state.accEls[i].body.querySelector('.fos-builder__grid');
      if (!grid) return;
      grid.innerHTML = '';
      var cache = eligibleProducts(slot.collection);
      if (!cache.length) {
        grid.innerHTML = '<div class="fos-builder__loading">' + escapeHtml(tt('emptyPool', 'Uygun ürün yok.')) + '</div>';
        return;
      }
      cache.forEach(function (p) {
        var card = document.createElement('div');
        card.className = 'fos-builder__card';
        var img = p.image ? '<img src="' + escapeHtml(imgUrl(p.image, 420)) + '" alt="" loading="lazy">' : '';
        // Görsel artık buton: tıklayınca hızlı inceleme katmanı açılır.
        // "İncele" rozeti tıklanabilirliği görünür kılar (üzerine gelince
        // belirir; dokunmatikte hep görünür).
        card.innerHTML =
          '<button type="button" class="fos-builder__card-img" data-qv-open aria-label="' +
            escapeHtml(p.title + ' — ' + tt('qvLook', 'İncele')) + '">' +
            img +
            '<span class="fos-builder__card-look" aria-hidden="true">' + ZOOM_ICON + escapeHtml(tt('qvLook', 'İncele')) + '</span>' +
          '</button>' +
          '<span class="fos-builder__card-title" data-qv-open>' + escapeHtml(p.title) + '</span>' +
          '<span class="fos-builder__card-price">' + money(p.price) + '</span>';
        card.querySelectorAll('[data-qv-open]').forEach(function (el) {
          el.addEventListener('click', function () {
            openQuickView(i, p, card.querySelector('.fos-builder__card-img'));
          });
        });
        card.appendChild(sizeRow(p, function (v) { pickSize(i, p, v); }));
        grid.appendChild(card);
      });
    });
    updateTotals(); // koleksiyonlar geldi → boş slot çapa tahmini artık dolu
  }

  /* Boş slotun çapa tahmini: slotta ürün varsa onun fiyatı; yoksa slotun
     koleksiyonundaki İLK uygun ürünün fiyatı (package-card.liquid'in canlı
     çapa konvansiyonuyla aynı); koleksiyon henüz yüklenmediyse aynı
     koleksiyondaki dolu bir slotun fiyatı. Hiçbiri yoksa 0 → avantaj
     rozeti o an gizlenir (asla uydurma sayı gösterilmez). */
  function slotEstimate(slot) {
    if (slot.variant) return slot.variant.price;
    if (slot.product && slot.product.price) return slot.product.price;
    var pool = eligibleProducts(slot.collection);
    if (pool.length) return pool[0].price;
    for (var i = 0; i < state.slots.length; i++) {
      var o = state.slots[i];
      if (o.collection !== slot.collection) continue;
      if (o.variant) return o.variant.price;
      if (o.product && o.product.price) return o.product.price;
    }
    return 0;
  }

  /* "x al, y öde" hattında avantaj sabit değil: seçilen üç parçanın en
     ucuzu bedava. Modalda canlı rakam göstermek, müşteri seçim değiştirdikçe
     oynayan bir vaat yaratıyor. Onun yerine ÜST SINIR yazılır — havuzdaki en
     pahalı ürünün fiyatı, yani kazanılabilecek en yüksek tutar. */
  function maxPoolPriceCents() {
    var max = 0;
    var seen = {};
    state.slots.forEach(function (slot) {
      if (slot.variant && slot.variant.price > max) max = slot.variant.price;
      var handle = slot.collection;
      if (!handle || seen[handle]) return;
      seen[handle] = true;
      eligibleProducts(handle).forEach(function (p) {
        if (p.price > max) max = p.price;
      });
    });
    return max;
  }

  /* ----- toplam / sayaç / buton ----- */
  function updateTotals() {
    var done = filledCount() === state.qty;
    var occupied = occupiedCount();

    // Canlı çapa: dolu slotlar gerçek fiyat, boşlar tahmin — müşteri paketi
    // kurarken avantajı O ANDA görsün (kayıptan kaçınma).
    var anchor = 0;
    var known = true;
    state.slots.forEach(function (s) {
      var est = slotEstimate(s);
      if (est > 0) { anchor += est; } else { known = false; }
    });
    // "x al, y öde" paketlerinde toplam sabit değil: çapadan en ucuz
    // y parçanın fiyatı düşülür. Müşteri seçtikçe rakam yerine oturur.
    if (state.freeQuantity > 0) {
      var estimates = state.slots
        .map(slotEstimate)
        .filter(function (v) { return v > 0; })
        .sort(function (a, b) { return a - b; });
      var freeCents = 0;
      for (var f = 0; f < state.freeQuantity && f < estimates.length; f++) {
        freeCents += estimates[f];
      }
      state.totalCents = Math.max(anchor - freeCents, 0);
    }

    var adv = known ? anchor - state.totalCents : 0;

    var totals = overlay.querySelector('[data-totals]');
    var bxgy = state.freeQuantity > 0;
    var html =
      '<span class="fos-builder__total-label">' +
        escapeHtml((done ? tt('packPrice', 'Paket fiyatı') : tt('packWhenDone', 'Paket tamamlanınca')) +
          ' · ' + tt('itemsCount', '__N__ ürün', { N: state.qty })) +
      '</span>';
    if (bxgy) {
      html +=
        '<span class="fos-builder__total is-text">' +
          escapeHtml(tt('bxgyHeadline', 'En ucuz parça bizden')) + '</span>';
      var cap = maxPoolPriceCents();
      if (cap > 0) {
        html +=
          '<span class="fos-builder__adv">' +
            escapeHtml(tt('advantageUpTo', '__AMOUNT__\'ye varan avantaj', { AMOUNT: money(cap) })) + '</span>';
      }
    } else {
      html += '<span class="fos-builder__total">' + money(state.totalCents) + '</span>';
      if (adv > 0) html += '<span class="fos-builder__adv">' + escapeHtml(tt('advantage', '__AMOUNT__ avantaj', { AMOUNT: money(adv) })) + '</span>';
    }
    totals.innerHTML = html;

    // Sayaç ürün bazlı: PDP'den açılışta 1/N ("otomatik eklendi ama
    // sayılmıyor" çelişkisi yok). Beden eksikse buton söyler.
    overlay.querySelector('[data-counter]').textContent =
      Math.min(occupied, state.qty) + '/' + state.qty;

    var addBtn = overlay.querySelector('[data-add]');
    addBtn.disabled = !done;
    if (done) {
      addBtn.textContent = tt('addToCart', 'Sepete Ekle');
    } else if (occupied === state.qty) {
      addBtn.textContent = tt('selectSize', 'Beden seç');
    } else {
      addBtn.textContent = tt('completePackCount', 'Paketi tamamla (__DONE__/__TOTAL__)', { DONE: occupied, TOTAL: state.qty });
    }
  }

  /* ----- sepete ekle ----- */
  function addToCart() {
    if (filledCount() !== state.qty) return;
    // Sepette zaten olan kilitli slotları tekrar EKLEME; yalnız yeni seçilenler.
    var items = state.slots
      .map(function (s, index) {
        if (s.inCart) return null;
        var item = { id: s.variant.id, quantity: 1 };
        if (state.packageKey) {
          item.properties = {
            _fos_package_key: state.packageKey,
            _fos_package_slot: String(index)
          };
        }
        return item;
      })
      .filter(Boolean);
    if (!items.length) { dismissBuilder(); return; }
    var addBtn = overlay.querySelector('[data-add]');
    addBtn.disabled = true;
    addBtn.textContent = tt('adding', 'Ekleniyor…');

    pendingCartWrite = pendingCartWrite
      .then(function () {
        return window.fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          addBtn.disabled = false;
          addBtn.textContent = tt('retry', 'Tekrar dene');
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:itemAdded', { detail: res.data }));
        if (state && state.source === 'pdp') {
          document.dispatchEvent(new CustomEvent('fos:pdp-package-builder-completed', {
            detail: { packageHandle: state.packageHandle }
          }));
        }
        dismissBuilder(); // seçimler zaten eklendi → kapanışta tekrar akıtma
        openCartDrawer();
      })
      .catch(function () {
        addBtn.disabled = false;
        addBtn.textContent = tt('retry', 'Tekrar dene');
      });
    return pendingCartWrite;
  }

  function pdpTierOptions(opt) {
    if (!DATA) return null;
    if (!opt) {
      var checked = document.querySelector('[data-fos-pack] .fos-opt__radio:checked');
      opt = checked ? checked.closest('.fos-opt') : null;
    }
    if (!opt || typeof opt.closest !== 'function') return null;
    var pack = opt.closest('[data-fos-pack]');
    if (!pack) return null;
    var qty = parseInt(opt.getAttribute('data-qty'), 10) || 1;
    if (qty <= 1) return null;
    var totalCents = parseInt(opt.getAttribute('data-total'), 10) || 0;
    return {
      qty: qty,
      totalCents: totalCents,
      freeQuantity: parseInt(opt.getAttribute('data-free'), 10) || 0,
      packageHandle: DATA.packageHandle || pack.getAttribute('data-pack-handle'),
      collection: COLLECTION,
      excludeTags: DATA.excludeTags || [],
      resumeFromCart: true,
      source: 'pdp',
      locked: [{ product: CUR, variant: preselectedCurrentVariant(), inCart: false }]
    };
  }

  function openPdpTier(opt) {
    var opts = pdpTierOptions(opt);
    if (!opts) return false;
    if (opts.locked[0].variant) {
      syncPartialPdpVariant(opts.locked[0].variant, opts);
    }
    openBuilder(opts);
    return true;
  }

  /* ----- PDP tetikleyici: 2'li/3'lü kademe seçilince aç (yalnız PDP'de) ----- */
  if (DATA) {
    document.addEventListener('click', function (e) {
      var opt = e.target.closest('.fos-opt');
      if (!opt) return;
      openPdpTier(opt);
    });

    document.addEventListener('fos:pdp-variant-changed', function (e) {
      var detail = e.detail || {};
      if (
        suppressPdpCartSync ||
        !detail.available ||
        !CUR ||
        String(detail.productId) !== String(CUR.id)
      ) return;
      var variant = currentProductVariant(detail.variantId);
      var builderIsOpen = !!(
        overlay &&
        overlay.getAttribute('aria-hidden') === 'false' &&
        state &&
        state.slots[0]
      );
      var opts = builderIsOpen && state.slots[0].inCart
        ? { packageKey: state.packageKey, qty: state.qty }
        : pdpTierOptions();
      if (!variant || !opts) return;
      if (builderIsOpen && !state.slots[0].inCart) return;
      syncPartialPdpVariant(variant, opts);
    });
  }

  /* ----- dışa açık API: sepet modülü / combo cross-sell kartı parametreyle
     açabilsin; currentProduct() mevcut ürünü (+ PDP'de seçili bedeni)
     paylaşır (cross-sell-combo.js kendi kopyasını tutmaz). ----- */
  window.fosBuilder = {
    open: openBuilder,
    openPdpTier: openPdpTier,
    currentProduct: function () {
      if (!CUR) return null;
      return { product: CUR, variant: preselectedCurrentVariant() };
    }
  };

  document.addEventListener('keydown', function (e) {
    if (!overlay || overlay.getAttribute('aria-hidden') !== 'false') return;
    if (e.key === 'Escape') {
      // Esc de kademeli: önce hızlı inceleme, sonra modal.
      if (qvIsOpen()) closeQuickView();
      else closeBuilder();
      return;
    }
    if (qvIsOpen() && qv.count > 1) {
      if (e.key === 'ArrowLeft') { qvGoto(qv.index - 1); }
      else if (e.key === 'ArrowRight') { qvGoto(qv.index + 1); }
    }
  });
})();
